{
  "GenericAdminFilterLanguage_CME_LABEL": "CME",
  "GenericAdminFilterLanguage_TELSYS_LABEL": "Servidor de Telefonia",
  "GenericAdminFilterLanguage_PARTITION_LABEL": "Partição",
  "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "Tipo de CRM",
  "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Incluir itens CME filhos",
  "GenericAdminFilterLanguage_SEARCH_LABEL": "Procurar",
  "NAME": "GenericAdminFilterLanguage"
}